import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- Interfaces ---
import type { IParameters, IParametersOptions } from '@interfaces/parameters';
import type { IPriceLists } from '@interfaces/priceLists';

export interface IUpdateParametersParams {
	dailyPassword?: string;
}

@Injectable({
	providedIn: 'root',
})
export class ParametersService {
	constructor(private readonly _http: HttpClient) {}

	// --- GET endpoints ---
	getParameters() {
		return this._http.get<IParameters>('preferences/parameters');
	}

	getOptions() {
		return this._http.get<IParametersOptions>('preferences/parameters/options');
	}

	getPriceList() {
		return this._http.get<IPriceLists>('price_lists');
	}

	// --- PUT endpoints ---
	updateParameters(
		parameters: IParameters,
		queryParams?: IUpdateParametersParams
	) {
		return this._http.put<IParameters>('preferences/parameters', parameters, {
			params: new HttpParams({ fromObject: queryParams as any }),
		});
	}
}
